import { render, staticRenderFns } from "./PieceWork.vue?vue&type=template&id=054aa20a&scoped=true"
import script from "./PieceWork.vue?vue&type=script&lang=js"
export * from "./PieceWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054aa20a",
  null
  
)

export default component.exports